var React = require('react');

function Prescription (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M379.32 274l-78.06 78L256 397.29l-78 78.07a16 16 0 0 1-22.63 0l-22.63-22.63a16 16 0 0 1 0-22.63l201.32-201.38a16 16 0 0 1 22.63 0l22.63 22.63a16 16 0 0 1 0 22.65z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M379.32 430.09l-78.06-78-45.26 45.2 78.06 78.06a16 16 0 0 0 22.63 0l22.63-22.63a16 16 0 0 0 0-22.63zM172 222.78c47.27-6 84-45.89 84-94.78a96 96 0 0 0-96-96H16A16 16 0 0 0 0 48v256a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-80h18.75l128 128L256 306.78zM64 160V96h96a32 32 0 1 1 0 64z","className":"fa-primary","key":2})]);
}

Prescription.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = Prescription;

Prescription.default = Prescription;
